import { defineStore } from "pinia";

interface SuggestionState {
  productsByCategoryId: Record<string, any[]>;
  loading: Record<string, boolean>;
  lastFetchTime: Record<string, number>;
  cacheDuration: number; // in milliseconds
}

export const useCartSuggestionsStore = defineStore("cartSuggestions", {
  state: (): SuggestionState => ({
    productsByCategoryId: {},
    loading: {},
    lastFetchTime: {},
    cacheDuration: 60 * 60 * 1000, // 60 minutes cache duration
  }),

  getters: {
    isCategoryLoading: (state) => (categoryId: string) => {
      return !!state.loading[categoryId];
    },
    
    getProductsByCategoryId: (state) => (categoryId: string) => {
      return state.productsByCategoryId[categoryId] || [];
    },
    
    shouldRefetch: (state) => (categoryId: string) => {
      const lastFetch = state.lastFetchTime[categoryId];
      if (!lastFetch) return true;
      
      const now = Date.now();
      return now - lastFetch > state.cacheDuration;
    }
  },

  actions: {
    setLoading(categoryId: string, isLoading: boolean) {
      this.loading = { ...this.loading, [categoryId]: isLoading };
    },
    
    setCategoryProducts(categoryId: string, products: any[]) {
      this.productsByCategoryId = { 
        ...this.productsByCategoryId, 
        [categoryId]: products 
      };
      this.lastFetchTime = { 
        ...this.lastFetchTime, 
        [categoryId]: Date.now() 
      };
    },
    
    clearCache() {
      this.productsByCategoryId = {};
      this.lastFetchTime = {};
    }
  }
});
